import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import "./style.css";

export default function Button({ button, onClick }) {
  return (
    <button className={`button ${button.type}`} onClick={onClick}>
      {button?.icon && <FontAwesomeIcon icon={button.icon} />}
      <span>{button.text}</span>
    </button>
  );
}
